export const MODAL_HEADER = 'Oops sorry...';
export const ERROR = 'Something went wrong while saving your changes.';
export const CONTACT_SUPPORT = 'Please check your internet connection or contact Innovation Support.';
export const SEE_FRONT_DESK = 'Please see front desk.';
export const HOME = 'Back to home';
export const LOGOUT = 'Logout';
